import React from "react";
import {
  Row,
  Col,
  Input,
  Button,
  Space,
  message,
  Modal,
  Form,
  Select,
  Image,
  Tooltip,
  Drawer,
  Checkbox,
  InputNumber
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import CompanyAutocomplete from "./CompanyAutocomplete";
import ListTable from "./ListTable";
import withRouter from "../withRouter";
import WASLVehicleStore from "../store/WASLVehicleStore";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import { Link } from "react-router-dom";
import { decode as base64_decode } from "base-64";
import Cookies from "js-cookie";
import { DeleteFilled, SearchOutlined } from "@ant-design/icons";
import DeleteConfirm from "./DeleteConfirm";
import config from "../config";
import { hasFeature } from "../utils/componentVisibility";
const features = {
  showWaslPermission: hasFeature("showWaslPermission"),
  showwaslactivity:hasFeature("showwaslactivity")
};
const { Option } = Select;
class WASLVehicleList extends React.Component {
  constructor(props) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeList = this.handleChangeList.bind(this);

    this.waslVehicleStore = new WASLVehicleStore();

    this.state = {
      showWASLRegistration: false,
      loading: false,
      exportLoading: false,
      pageSize: 50,
      currentPage: 1,
      openConfirm: false,
      confirmLoading: false,
      loadList: 0,
      Company: true,
      Individual: false,
      cname: "",
      identityNo: "",
      crNo: "",
      loadData: 0,
      companyId: "",
      selectVehicle: "",
      UcompanyId: "",
      cid: "",
      waslInquiryPopup: false,
      showAlertModal: false,
      vehicleId: "",
      showSensors: false,
      hasTemperatureSensor: false,
      hasHumiditySensor: false,
    };
    this.formRef = React.createRef();
  }

  async componentDidUpdate(prevProps, prevState) {
    if (
      Number(this.props.getUserData().isadmin) === 1 ||
      Number(this.props.getUserData().isadmin) === 0
    ) {
      this.props.navigate("/login");
    }
  }
  async componentDidMount() {
    if (this.props.getUserData().isadmin === 3) {
      await this.setState({ companyId: 0, vehicleId: 0 });
    }
    if (features.showwaslactivity) {
      await this.waslVehicleStore.getWASLvehicleActivity();
    }

    this.setState({ pageSize: 50 });

    this.columns = [
      {
        title: this.context.translate("_ACCOUNT_"),
        dataIndex: "name",
        key: "name",
        width: 12,
        ellipsis: true,
      },
      {
        title: this.context.translate("_VEHICLE_NO_"),
        dataIndex: "vehicleNo",
        key: "vehicleNo",
        width: 10,
        ellipsis: true,
      },
      {
        title: this.context.translate("_SEQUENCE_NUMBER_"),
        dataIndex: "sequenceNo",
        key: "sequenceNo",
        width: 13,
        ellipsis: true,
      },
      {
        title: this.context.translate("_NUMBER_"),
        dataIndex: "plateNo",
        key: "plateNo",
        width: 12,
        ellipsis: true,
      },
      {
        title: this.context.translate("_RIGHT_LETTER"),
        dataIndex: "plateRightLetter",
        key: "plateRightLetter",
        width: 15,
        ellipsis: true,
      },
      {
        title: this.context.translate("_MIDDLE_LETTER_"),
        dataIndex: "plateMiddleLetter",
        key: "plateMiddleLetter",
        width: 12,
        ellipsis: true,
      },
      {
        title: this.context.translate("_LEFT_LETTER_"),
        dataIndex: "plateLeftLetter",
        key: "plateLeftLetter",
        width: 12,
        ellipsis: true,
      },
      {
        title: this.context.translate("_PLATE_TYPE_"),
        dataIndex: "plateType",
        key: "plateType",
        width: 11,
        ellipsis: true,
      },
      {
        title: this.context.translate("_IMEI_NUMBER_"),
        dataIndex: "imeiNo",
        key: "imeiNo",
        width: 15,
        ellipsis: true,
      },
      {
        title: this.context.translate("_WASL_VEHICLE_KEY_"),
        dataIndex: "waslVehicleKey",
        key: "waslVehicleKey",
        width: 11,
        ellipsis: true,
      },
      {
        title: this.context.translate("_RESPONSE_"),
        dataIndex: "response",
        key: "response",
        width: 9,
        ellipsis: true,
      },

      {
        title: this.context.translate("_REGISTRATION_DATE_"),
        dataIndex: "createDate",
        key: "createDate",
        width: 15,
        ellipsis: true,
      },
      {
        title: this.context.translate("_ACTIVITY_"),
        dataIndex: "activity",
        key: "activity",
        width: 8,
        ellipsis: true,
      },
      {
        title: this.context.translate("_REPLY_"),
        dataIndex: "reply",
        key: "reply",
        width: 7,
        ellipsis: true,
      },
      {
        title: this.context.translate("_ACTION_"),
        dataIndex: "Action",
        // fixed: "right",
        width: 7,
        ellipsis: true,
        render: (_, record) => {
          return (
            <>
              <Space>
                {/* <SearchOutlined
                  onClick={async () => {
                    await this.WASLVehicleStatus(record);
                  }}
                /> */}
                <SearchOutlined
                  onClick={async () => {
                    const response = await this.waslVehicleStore.getWASLVehicleStatus(record);

                    if (response) {
                      this.setState({
                        waslInquiryPopup: true,
                        showAlertModal: false,
                        loadData: 1,
                      });
                    } else {
                      this.setState({
                        waslInquiryPopup: false,
                        showAlertModal: true,
                        loadData: 1,
                      });
                    }
                  }}
                />

                {features.showWaslPermission ? (
                  this.props.canDelete("waslvehicle") && (
                    <DeleteConfirm
                      onConfirm={(e) => {
                        this.onDelete(record);
                      }}
                    >
                      <Link
                        onClick={(e) => {
                          e.preventDefault();
                        }}
                      >
                        <DeleteFilled style={{ color: config.deleteColor }} />
                      </Link>
                    </DeleteConfirm>
                  )
                ) : (
                  <DeleteConfirm
                    onConfirm={(e) => {
                      this.onDelete(record);
                    }}
                  >
                    <Link
                      onClick={(e) => {
                        e.preventDefault();
                      }}
                    >
                      <DeleteFilled style={{ color: config.deleteColor }} />
                    </Link>
                  </DeleteConfirm>
                )}
              </Space>
            </>
          );
        },
      },
    ];
    await this.handleSearch();
  }

  WASLVehicleStatus = async (record) => {
    await this.waslVehicleStore.getWASLVehicleStatus(record);
  };

  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    this.handleSearch();
  }

  async handleChange(comp) {
    await this.setState({ companyId: comp.value, loadList: 1 });

    await this.waslVehicleStore.getVehiclesByCompanyId({
      companyId: comp.value,
    });

    await this.waslVehicleStore.getCompanyIdentityNo(comp.value);

    this.setState({ loadData: 1 , pageSize: 50, currentPage: 1});
    // await this.handleSearch();
  }

  async handleChangeList(comp) {
    await this.setState({ companyId: comp.value, loadList: 1 });

    await this.waslVehicleStore.getVehiclesByCompanyId({
      companyId: comp.value,
    });

    // await this.waslVehicleStore.getCompanyIdentityNo(comp.value);

    this.setState({ loadData: 1 });
    await this.handleSearch();
  }
  async handleSearch() {
    this.setState({ loading: true });

    await this.waslVehicleStore.loadData({
      companyId: this.state.companyId,
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      vehicleId: this.state.selectVehicle,
      sequenceNo: this.state.sequenceNo,
      UcompanyId:
        this.props.getUserData().isadmin === 3
          ? this.props.getUserData().userCompanyId
          : 0,
    });
    await this.setState({ loadList: 0 });
  }

  onWASLVehicleRegistrationFinish = async (value) => {
    const data = {
      ...value,
      userId: this.props.getUserData().userId,
      companyId: this.state.companyId,
    };

    const response = await this.waslVehicleStore.registerVehicle(data);
    if (response?.success === "S" || response?.data?.success === "S") {
      message.success(response.data.message);
    } else {
      message.error(response.data.message);
    }
    if (response.data.message) {
      this.setState({ showWASLRegistration: false });
      this.formRef.current?.resetFields();
    }
  };

  searchInput = async (e) => {
    const value = e.target.value;
    // await this.setState({searchField:value})
    if (value.length > 2 || value.length === 0) {
      await this.waslVehicleStore.loadData({
        offset: 0,
        limit: this.state.pageSize,
        sequenceNo: value,
        companyId: this.state.companyId,
      });
      await this.setState({ loadList: 1 });
    }
  };

  validateNumber = (value, field) => {
    const value1 = value.replace(/[^0-9+]*/g, "");

    if (value1) {
      this.formRef.current.setFieldsValue({ [field]: value1 });
    } else {
      this.formRef.current.setFieldsValue({ [field]: "" });
    }
  };

  // setFieldsValues = async (vehicleId) => {
  //   const data = await this.waslVehicleStore.getVehicleInfo(vehicleId);

  //   await this.formRef.current.setFieldsValue({ imeiNumber: data?.full_imei });
  //   await this.formRef.current.setFieldsValue({ number: data?.vehicleNo });
  //   await this.formRef.current.setFieldsValue({
  //     sequenceNumber: data?.sequenceNo,
  //   });
  //   await this.formRef.current.setFieldsValue({ plateType: data?.plateType });

  //   await this.formRef.current.setFieldsValue({ simNumber: data?.simNo });
  //   await this.formRef.current.setFieldsValue({ weightInKilogramsEmptyVehicle: data?.emptyWeight });
  //   await this.formRef.current.setFieldsValue({ deviceBrand: data?.deviceName });
  //   await this.formRef.current.setFieldsValue({ deviceModel: data?.deviceBrandName });
  //   await this.formRef.current.setFieldsValue({ telecomCompanyName: data?.simType });
  //   await this.formRef.current.setFieldsValue({ weightSensorAnalogNumber: data?.weightSensorAnalogNumber });
  //   await this.formRef.current.setFieldsValue({ weightInKilogramsHalfLoad: data?.weightInKilogramsHalfLoad });
  //   await this.formRef.current.setFieldsValue({ weightInKilogramsFullLoad: data?.weightInKilogramsFullLoad });
  //   await this.formRef.current.setFieldsValue({ mlVoltageEmptyVehicle: data?.mlVoltageEmptyVehicle });
  //   await this.formRef.current.setFieldsValue({ mlVoltageHalfLoad: data?.mlVoltageHalfLoad });
  //   await this.formRef.current.setFieldsValue({ mlVoltageFullLoad: data?.mlVoltageFullLoad });

    
  // };

  setFieldsValues = async (vehicleId) => {
    
    const data = await this.waslVehicleStore.getVehicleInfo(vehicleId);
    const activity = this.formRef.current.getFieldValue("activity") || "DEFAULT";

    this.formRef.current.setFieldsValue({
      imeiNumber: data?.full_imei,
      number: data?.vehicleNo,
      sequenceNumber: data?.sequenceNo,
      plateType: data?.plateType,
      simNumber: data?.simNo,
      weightInKilogramsEmptyVehicle: data?.emptyWeight,
      deviceBrand: data?.deviceName,
      deviceModel: data?.deviceBrandName,
      telecomCompanyName: data?.simType,
      weightSensorAnalogNumber: data?.weightSensorAnalogNumber,
      weightInKilogramsHalfLoad: data?.weightInKilogramsHalfLoad,
      weightInKilogramsFullLoad: data?.weightInKilogramsFullLoad,
      mlVoltageEmptyVehicle: data?.mlVoltageEmptyVehicle,
      mlVoltageHalfLoad: data?.mlVoltageHalfLoad,
      mlVoltageFullLoad: data?.mlVoltageFullLoad,
    });

    if (activity !== "DEFAULT") {

      this.formRef.current.setFieldsValue({
        hasTemperatureSensor: data?.hasTemperatureSensor == 1,
        hasHumiditySensor: data?.hasHumiditySensor == 1,
        temperatureAnalogNumber: data?.temperatureAnalogNumber,
        humidityAnalogNumber: data?.humidityAnalogNumber,
      });

      this.setState({
        hasTemperatureSensor: data?.hasTemperatureSensor == 1,
        hasHumiditySensor: data?.hasHumiditySensor == 1,
      });
    } else {
      
      this.formRef.current.setFieldsValue({
        hasTemperatureSensor: false,
        hasHumiditySensor: false,
        temperatureAnalogNumber: null,
        humidityAnalogNumber: null,
      });

      this.setState({
        hasTemperatureSensor: false,
        hasHumiditySensor: false,
      });
    }

  };

  handleActivityChange = async (value) => {
  
    this.setState({
      activity: value,
      showSensors: value !== "DEFAULT",
    });

    if (value === "DEFAULT") {
      this.formRef.current?.setFieldsValue({
        hasTemperatureSensor: false,
        hasHumiditySensor: false,
        temperatureAnalogNumber: null,
        humidityAnalogNumber: null,
      });
    }
  };

  async onDelete(record) {
    const response = await this.waslVehicleStore.deleteRecord({
      Id: record.Id,
      companyId: record.companyId,
      waslkey: record.waslVehicleKey,
      userId: this.props.getUserData().userId,
    });

    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }

  render() {
    const {
      referenceKey,
      name,
      plate,
      vehicleIMEI,
      vehicleLocationInformation,
      operatingCompanies,
    } = this.waslVehicleStore?.inquiryStatus || {};
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Space>
              <CompanyAutocomplete
                className="searchInput"
                onChange={(value) => {
                  this.handleChangeList(value);
                }}
                style={{ width: 200 }}
              />

              <Select
                className="searchInput"
                onSelect={async (val) => {
                  await this.setState({ selectVehicle: val });
                  await this.handleSearch();
                }}
                showSearch
                // fieldNames={{ label: "vehicleNo", value: "vehicleId" }}
                placeholder={this.context.translate("_ASSET_NAME_")}
                // placeholder="Asset Name"

                optionFilterProp="children"
                // options={this.waslVehicleStore?.getVehiclesUsingCompanyId}
                style={{ width: 160 }}
                filterOption={(inputValue, option) => {
                  if (option.children) {
                    return (
                      option.children
                        .toLowerCase()
                        .indexOf(inputValue.toLowerCase()) >= 0
                    );
                  }
                }}
              >
                {this.waslVehicleStore?.getVehiclesUsingCompanyId?.map(
                  (val) => {
                    return (
                      <Option value={val.vehicleId} key={val.vehicleId}>
                        {val.vehicleNo}
                      </Option>
                    );
                  }
                )}
              </Select>

              <Input
                style={{ width: 200, borderRadius: "25px" }}
                placeholder={this.context.translate("_SEQUENCE_NUMBER_")}
                // placeholder="Sequence Number"
                onChange={async (e) => {
                  await this.setState({ sequenceNo: e.target.value });
                  await this.searchInput(e);
                  // await this.handleSearch()
                }}
              ></Input>

              {/* <Button type="primary" onClick={() => this.handleSearch()}>
                <SearchOutlined />
              </Button> */}
            </Space>

            <Space
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Link to={"/vehiclelist"}>
                <Button className="addButtonClass">
                  {this.context.translate("_BACK_")}
                </Button>
              </Link>
              {features.showWaslPermission ? (
                this.props.canCreate("waslvehicle") && (
                  <Button
                    className="addButtonClass"
                    // type="primary"
                    onClick={() =>
                      this.setState({ showWASLRegistration: true })
                    }
                  >
                    <Image
                      style={{ marginInlineEnd: "5px", width: 13 }}
                      src={require("../assets/images/NewDesign/plus (Stroke).png")}
                    />
                    {this.context.translate("_REGISTER_")}
                  </Button>
                )
              ) : (
                <Button
                  className="addButtonClass"
                  // type="primary"
                  onClick={() => this.setState({ showWASLRegistration: true })}
                >
                  <Image
                    style={{ marginInlineEnd: "5px", width: 13 }}
                    src={require("../assets/images/NewDesign/plus (Stroke).png")}
                  />
                  {this.context.translate("_REGISTER_")}
                </Button>
              )}

              <Button
                className={`downloadExcelButton ${
                    this.state.exportLoading ? "downloadExcelButtonLoading" : ""
                  }`}
                loading={this.state.exportLoading}
                disabled={ this.waslVehicleStore?.WASLVehicleArray?.length > 0 ? false : true }

                onClick={async () => {

                  const result = [];
                  await this.columns.map((obj) => result.push(obj.dataIndex));
                  var getData = {
                    companyId: this.state.companyId,
                    UcompanyId: JSON.parse(base64_decode(Cookies.get("data"))).UcompanyId,
                    vehicleId: this.state.selectVehicle,
                    sequenceNo: this.state.sequenceNo,
                    colList: result,
                  };

                  this.setState({ exportLoading: true });

                  try {
                    await this.waslVehicleStore.exportExcel(getData);
                  } catch (error) {
                    message.error("Failed to export Excel");
                    this.setState({ exportLoading: false });
                  } finally {
                    this.setState({ exportLoading: false });
                  }

                }}
              >
                <Tooltip title="Download Excel" placement="bottom">
                  <Image
                    style={{
                      height: 18,
                      width: "auto",
                    }}
                    src={downloadIcon}
                  />
                </Tooltip>
              </Button>
            </Space>
          </Row>

          <ListTable
            current={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.waslVehicleStore?.total}
            columns={this.columns}
            // dataSource={this.dataSource}
            dataSource={this.waslVehicleStore?.WASLVehicleArray}
            loading={this.waslVehicleStore?.loading}
            onChange={this.handleTableChange}
            scroll={{
              x: 1800,
            }}
          />

          {/* <Modal
            title={this.context.translate("_WASL_REGISTRATION_")}
            destroyOnClose={true}
            open={this.state.showWASLRegistration}
            onCancel={() => this.setState({ showWASLRegistration: false })}
            footer={null}
            width={645}
            centered
          > */}
          <Drawer
            className="accountFormDrawer"
            width={716}
            closeIcon={false}
            open={this.state.showWASLRegistration}
            placement={
              this.context.locale.language === "arabic" ? "left" : "right"
            }
            title={
              <div className="formTitle">
                {this.context.translate("_WASL_REGISTRATION_")}
                <p className="formDescription">
                  {this.context.translate("_DRIVER_ADD_DESC_")}
                </p>
              </div>
            }
            footer={false}
            maskClosable={false}
            onOk={() => this.setState({ showWASLRegistration: false })}
            onCancel={() =>
              this.setState({
                showWASLRegistration: false,
              })
            }
          >
            <div style={{ padding: 0, height: "100%" }}>
              <Form
                ref={this.formRef}
                layout="vertical"
                name="companyFrm"
                onFinish={this.onWASLVehicleRegistrationFinish}
                style={{ maxWidth: "100%", padding: 0, height: "92%" }}
                className="formClass"
              >
                <Row className="overflowFormInputs">
                  <Col span={12} className="waslFormClass">
                    <Form.Item
                      className="formFieldsStyle"
                      name="companyId"
                      label={
                        <span>
                          {this.context.translate("_ACCOUNT_")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: `${this.context.translate(
                            "_FLEET_DRIVER_DRIVERDETAIL_COMPANY_"
                          )} ${this.context.translate("_IS_REQUIRED_")}`,
                        },
                      ]}
                    >
                      <CompanyAutocomplete
                        onChange={(value) => {
                          this.handleChange(value);
                        }}
                        style={{ width: "100%" }}
                      />
                    </Form.Item>
            
                    <Form.Item
                      className="formFieldsStyle"
                      name="cidentityNo"
                      label={
                        <span>
                          {this.context.translate("_COMPANY_IDENTITY_NUMBER_")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: `${this.context.translate(
                            "_FLEET_DRIVER_DRIVERDETAIL_COMPANY_"
                          )} ${this.context.translate("_IS_REQUIRED_")}`,
                        },
                      ]}
                    >
                      <Select
                        placeholder={this.context.translate(
                          "_SELECT_COMPANY_IDENTITY_NUMBER_"
                        )}
                        showSearch
                        fieldNames={{
                          value: "identityNo",
                          label: "identityActivity",
                        }}
                        optionFilterProp="children"
                        options={this.waslVehicleStore?.CompanyIdentityNumbers}
                      />
                    </Form.Item>

                    <Form.Item
                      className="formFieldsStyle"
                      name="vehicleId"
                      label={
                        <span>
                          {this.context.translate(
                            "_FLEET_VEHICLE_VEHICLELIST_VEHICLENO_"
                          )}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: `${this.context.translate(
                            "_FLEET_VEHICLE_VEHICLELIST_VEHICLENO_"
                          )} ${this.context.translate("_IS_REQUIRED_")}`,
                        },
                      ]}
                    >
                      <Select
                        onChange={async (e) => await this.setFieldsValues(e)}
                        // fieldNames={{
                        //   label: "vehicleNo",
                        //   value: "vehicleId",
                        // }}
                        placeholder={this.context.translate("_ASSET_NAME_")}
                        // placeholder="Asset Name"
                        optionFilterProp="children"
                        // options={
                        //   this.waslVehicleStore?.getVehiclesUsingCompanyId
                        // }
                        showSearch
                        style={{ width: "100%" }}
                        filterOption={(inputValue, option) => {
                          if (option.children) {
                            return (
                              option.children
                                .toLowerCase()
                                .indexOf(inputValue.toLowerCase()) >= 0
                            );
                          }
                        }}
                      >
                        {this.waslVehicleStore?.getVehiclesUsingCompanyId?.map(
                          (val) => {
                            return (
                              <Option value={val.vehicleId} key={val.vehicleId}>
                                {val.vehicleNo}
                              </Option>
                            );
                          }
                        )}
                      </Select>
                    </Form.Item>
                    
                    <Form.Item
                      className="formFieldsStyle"
                      name="telecomCompanyName"
                      label={
                        <span>
                          {this.context.translate("_TELECOM_COMPANY_NAME_")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: `${this.context.translate(
                            "_TELECOM_COMPANY_NAME_"
                          )} ${this.context.translate("_IS_REQUIRED_")}`,
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      className="formFieldsStyle"
                      name="deviceBrand"
                      label={
                        <span>
                          {this.context.translate("_DEVICE_BRAND_")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: `${this.context.translate(
                            "_DEVICE_BRAND_"
                          )} ${this.context.translate("_IS_REQUIRED_")}`,
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      className="formFieldsStyle"
                      name="deviceModel"
                      label={
                        <span>
                          {this.context.translate("_DEVICE_MODEL_")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: `${this.context.translate(
                            "_DEVICE_MODEL_"
                          )} ${this.context.translate("_IS_REQUIRED_")}`,
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      className="formFieldsStyle"
                      name="sequenceNumber"
                      label={
                        <span>
                          {this.context.translate("_SEQUENCE_NUMBER_")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: `${this.context.translate(
                            "_SEQUENCE_NUMBER_"
                          )} ${this.context.translate("_IS_REQUIRED_")}`,
                        },
                      ]}
                    >
                      <Input
                        onChange={(e) =>
                          this.validateNumber(e.target.value, "sequenceNumber")
                        }
                      />
                    </Form.Item>

                    <Form.Item
                      className="formFieldsStyle"
                      name="imeiNumber"
                      label={
                        <span>
                          {this.context.translate("_IMEI_NUMBER_")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: `${this.context.translate(
                            "_IMEI_NUMBER_"
                          )} ${this.context.translate("_IS_REQUIRED_")}`,
                        },
                      ]}
                    >
                      <Input
                        onChange={(e) =>
                          this.validateNumber(e.target.value, "imeiNumber")
                        }
                      />
                    </Form.Item>

                    <Form.Item
                      className="formFieldsStyle"
                      name="simNumber"
                      label={
                        <span>
                          {this.context.translate("_SIM_NO_")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: `${this.context.translate(
                            "_SIM_NO_"
                          )} ${this.context.translate("_IS_REQUIRED_")}`,
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      className="formFieldsStyle"
                      name="number"
                      label={
                        <span>
                          {this.context.translate("_PLATE_REGISTER_NUMBER_")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: `${this.context.translate(
                            "_PLATE_REGISTER_NUMBER_"
                          )} ${this.context.translate("_IS_REQUIRED_")}`,
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      className="formFieldsStyle"
                      name="plateType"
                      label={
                        <span>
                          {this.context.translate("_PLATE_TYPE_")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: `${this.context.translate(
                            "_PLATE_TYPE_"
                          )} ${this.context.translate("_IS_REQUIRED_")}`,
                        },
                      ]}
                    >
                      <Select
                        style={{ width: "100%" }}
                        placeholder={this.context.translate("_SELECT_TYPE_")}
                      >
                        <Select.Option value="1">
                          {this.context.translate("__PRIVATE_CAR_")}
                        </Select.Option>
                        <Select.Option value="2">
                          {this.context.translate("_PUBLIC_TRANSPORT_")}
                        </Select.Option>
                        <Select.Option value="3">
                          {this.context.translate("_PRIVATE_TRANSPORT_")}
                        </Select.Option>
                        <Select.Option value="4">
                          {" "}
                          {this.context.translate("_PUBLIC_MINIBUS_")}
                        </Select.Option>
                        <Select.Option value="5">
                          {this.context.translate("_PRIVATE_MINIBUS_")}
                        </Select.Option>
                        <Select.Option value="6">
                          {this.context.translate("_TAXI_")}
                        </Select.Option>
                        <Select.Option value="7">
                          {this.context.translate("_HEAVY_EQUIPMENT_")}
                        </Select.Option>
                        <Select.Option value="8">
                          {this.context.translate("_EXPORT_")}
                        </Select.Option>
                        <Select.Option value="9">
                          {this.context.translate("_DIPLOMATIC_")}
                        </Select.Option>
                        <Select.Option value="10">
                          {this.context.translate("_MOTORCYCLE_")}
                        </Select.Option>
                        <Select.Option value="11">
                          {this.context.translate("_TEMPORARY_")}
                        </Select.Option>
                      </Select>
                    </Form.Item>

                    {! features.showwaslactivity ?
                      <Form.Item
                        className="formFieldsStyle"
                        name="activity"
                        initialValue={"DEFAULT"}
                        label={
                          <span>
                            {this.context.translate("_ACTIVITY_")}{" "}
                            <span style={{ color: "red" }}>*</span>
                          </span>
                        }
                        required={false}
                        rules={[
                          {
                            required: true,
                            message: `${this.context.translate(
                              "_ACTIVITY_"
                            )} ${this.context.translate("_IS_REQUIRED_")}`,
                          },
                        ]}
                      >
                        <Select onChange={this.handleActivityChange} autoClearSearchValue>
                          <Select.Option value="DEFAULT">
                            {" "}
                            {this.context.translate("_DEFAULT_")}
                          </Select.Option>
                          <Select.Option value="TOW_CAR">
                            {this.context.translate("_TOW_CAR_")}
                          </Select.Option>
                          <Select.Option value="SPECIALITY_TRANSPORT">
                            {this.context.translate("_SPECIALITY_TRANSPORT_")}
                          </Select.Option>
                          <Select.Option value="BUS_RENTAL">
                            {this.context.translate("_BUS_RENTAL_")}
                          </Select.Option>
                          <Select.Option value="EDUCATIONAL_TRANSPORT">
                            {this.context.translate("_EDUCATIONAL_TRANSPORT_")}
                          </Select.Option>
                          <Select.Option value="SFDA">
                            {this.context.translate("_SFDA_")}
                          </Select.Option>
                        </Select>
                      </Form.Item> :
                      <Form.Item
                        className="formFieldsStyle"
                        name="activity"
                        label={
                          <span>
                            {this.context.translate("_ACTIVITY_")}{" "}
                            <span style={{ color: "red" }}>*</span>
                          </span>
                        }
                        required={false}
                        rules={[
                          {
                            required: true,
                            message: `${this.context.translate(
                              "_ACTIVITY_"
                            )} ${this.context.translate("_IS_REQUIRED_")}`,
                          },
                        ]}
                      >
                        <Select
                          showSearch
                          autoClearSearchValue
                          options={this.waslVehicleStore.waslactivity?.map(
                            (item) => ({
                              value: item.name,
                              label: item.name,
                            })
                          )}
                        />
                    </Form.Item>}

                  </Col>

                  <Col span={12} className="waslFormClass">

                    {this.state.showSensors && (
                      <>
                        <Form.Item label=" ">
                          <Checkbox
                            checked={this.state.hasTemperatureSensor}
                            onChange={(e) =>
                              this.setState({
                                hasTemperatureSensor: e.target.checked,
                              })
                            }
                          >
                            {this.context.translate("_TEMPERATURE_SENSOR_")}
                          </Checkbox>
                        </Form.Item>

                        {this.state.hasTemperatureSensor && (
                          <Form.Item
                            name="temperatureAnalogNumber"
                            label={
                              <>
                                {this.context.translate("_TEMPERATURE_ANALOG_SENSOR_")}
                                <span style={{ color: "red" }}> *</span>
                              </>
                            }
                            rules={[{ required: true }]}
                          >
                            <InputNumber
                              min={1}
                              max={4}
                              precision={0}
                              style={{ width: "100%" }}
                            />
                          </Form.Item>
                        )}

                        <Form.Item label=" ">
                          <Checkbox
                            checked={this.state.hasHumiditySensor}
                            onChange={(e) =>
                              this.setState({
                                hasHumiditySensor: e.target.checked,
                              })
                            }
                          >
                            {this.context.translate("_HUMIDITY_SENSOR_")}
                          </Checkbox>
                        </Form.Item>

                        {this.state.hasHumiditySensor && (
                          <Form.Item
                            name="humidityAnalogNumber"
                            label={
                              <>
                                {this.context.translate("_HUMIDITY_ANALOG_SENSOR_")}
                                <span style={{ color: "red" }}> *</span>
                              </>
                            }
                            rules={[{ required: true }]}
                          >
                            <InputNumber
                              min={1}
                              max={4}
                              precision={0}
                              style={{ width: "100%" }}
                            />
                          </Form.Item>
                        )}
                      </>
                    )}

                    <Form.Item
                      className="formFieldsStyle"
                      name="weightSensorAnalogNumber"
                      label={
                        <span>
                          {this.context.translate("_WEIGHT_SENSOR_ANALOG_NUMBER_")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: `${this.context.translate(
                            "_WEIGHT_SENSOR_ANALOG_NUMBER_"
                          )} ${this.context.translate("_IS_REQUIRED_")}`,
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      className="formFieldsStyle"
                      name="weightInKilogramsEmptyVehicle"
                      label={
                        <span>
                          {this.context.translate("_EMPTY_TRUCK_WEIGHT_")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: `${this.context.translate(
                            "_EMPTY_TRUCK_WEIGHT_"
                          )} ${this.context.translate("_IS_REQUIRED_")}`,
                        },
                      ]}
                    >
                     <Input />
                    </Form.Item>

                    <Form.Item
                      className="formFieldsStyle"
                      name="weightInKilogramsHalfLoad"
                      label={
                        <span>
                          {this.context.translate("_VEHICLE_WEIGHT_HALF_LOAD_")}{" "}
                        </span>
                      }
                      required={false}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      className="formFieldsStyle"
                      name="weightInKilogramsFullLoad"
                      label={
                        <span>
                          {this.context.translate("_VEHICLE_WEIGHT_FULL_LOAD_")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: `${this.context.translate(
                            "_VEHICLE_WEIGHT_FULL_LOAD_"
                          )} ${this.context.translate("_IS_REQUIRED_")}`,
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      className="formFieldsStyle"
                      name="mlVoltageEmptyVehicle"
                      label={
                        <span>
                          {this.context.translate("_SENSOR_VOLTAGE_EMPTY_VEHICLE_")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: `${this.context.translate(
                            "_SENSOR_VOLTAGE_EMPTY_VEHICLE_"
                          )} ${this.context.translate("_IS_REQUIRED_")}`,
                        },
                      ]}
                    >
                     <Input />
                    </Form.Item>

                    <Form.Item
                      className="formFieldsStyle"
                      name="mlVoltageHalfLoad"
                      label={
                        <span>
                          {this.context.translate("_SENSOR_VOLTAGE_HALF_LOAD_")}{" "}
                        </span>
                      }
                      required={false}
                    >
                      <Input />
                    </Form.Item>
                    
                     <Form.Item
                      className="formFieldsStyle"
                      name="mlVoltageFullLoad"
                      label={
                        <span>
                          {this.context.translate("_SENSOR_VOLTAGE_FULL_LOAD_")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: `${this.context.translate(
                            "_SENSOR_VOLTAGE_FULL_LOAD_"
                          )} ${this.context.translate("_IS_REQUIRED_")}`,
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                    
                  </Col>
                </Row>

                <div className="formFooter">
                  <Button
                    className="formsCancelButton"
                    onClick={() => {
                      this.setState({ showWASLRegistration: false });
                    }}
                  >
                    {this.context.translate(
                      "_FLEET_DASHBORD_ROUTEADD_CANCELBTN_"
                    )}
                  </Button>
                  <Button htmlType="submit" className="formsSaveButton">
                    {this.context.translate("_REGISTER_")}
                  </Button>
                </div>
              </Form>
            </div>
          </Drawer>
        </div>

        <Modal
          width={350}
          className="alert-model"
          title={
            <div>
              {" "}
              <i
                style={{ color: "red", fontSize: "18px", marginRight: "5px" }}
                class="bi bi-exclamation-triangle"
              ></i>{" "}
              {this.context.translate("_FLEET_ALERT_")}
            </div>
          }
          open={this.state.showAlertModal}
          onOk={() => this.setState({ showAlertModal: false })}
          onCancel={() => this.setState({ showAlertModal: false })}
          okText="OK"
          cancelText="Cancel"
          footer={[
            <Button
              type="primary"
              onClick={() => this.setState({ showAlertModal: false })}
            >
              {this.context.translate("_FLEET_DASHBORD_VEHICLE_COMMAND_OKBTN_")}
            </Button>,
          ]}
        >
          <p>{this.waslVehicleStore?.WASLVehicleStatus}</p>
        </Modal>

        <Modal
          width={550}
          className="alert-model"
          title={this.context.translate("_INFORMATION_")}
          open={this.state.waslInquiryPopup}
          onOk={() => this.setState({ waslInquiryPopup: false })}
          onCancel={() => this.setState({ waslInquiryPopup: false })}
          okText="OK"
          cancelText="Cancel"
          footer={null}
        >
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <b>{this.context.translate("_REFERENCE_KEY_")}:</b>
              <span>{referenceKey}</span>
            </div>
            <b>{this.context.translate("_PLATE_INFORMATION_")}</b>:
            <span style={{ display: "block" }}>
              Right Letter: {plate?.rightLetter}
            </span>
            <span style={{ display: "block" }}>
              Middle Letter: {plate?.middleLetter}
            </span>
            <span style={{ display: "block" }}>
              Left Letter:{plate?.leftLetter}
            </span>
            <span style={{ display: "block" }}>Number: {plate?.number}</span>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span>
                {this.context.translate("_FLEET_DASHBORD_SETTING_IMEI_")}:
              </span>
              <span>{vehicleIMEI}</span>
            </div>
            <b>{this.context.translate("Vehicle Location Information")}</b>:
            <span style={{ display: "block" }}>
              {this.context.translate("_FLEET_DASHBORD_SETTING_LATITUDE_")}:{" "}
              {vehicleLocationInformation?.latitude}
            </span>
            <span style={{ display: "block" }}>
              {this.context.translate("_FLEET_DASHBORD_SETTING_LONGITUDE_")}:{" "}
              {vehicleLocationInformation?.longitude}
            </span>
            <span style={{ display: "block" }}>
              {this.context.translate("_VEHICLE_STATUS_")}:{" "}
              {vehicleLocationInformation?.vehicleStatus}
            </span>
            <span style={{ display: "block" }}>
              {this.context.translate("Actual Time")}:{" "}
              {vehicleLocationInformation?.actualTime}
            </span>
            <span style={{ display: "block" }}>
              {this.context.translate("Received Time")}:{" "}
              {vehicleLocationInformation?.receivedTime}
            </span>
            <b>{this.context.translate("_OPERATING_COMPANY_INFORMATION_")}</b>:
            {operatingCompanies?.[0] && (
              <>
                {" "}
                <span style={{ display: "block" }}>
                  {this.context.translate("_REFERENCE_KEY_")}:{" "}
                  {operatingCompanies[0]?.referenceKey}
                </span>
                <span style={{ display: "block" }}>
                  {this.context.translate("_FLEET_DASHBORD_NEWPOI_NAME_")}:{" "}
                  {operatingCompanies[0]?.name}
                </span>
                <span style={{ display: "block" }}>
                  {this.context.translate("_IS_VEHICLE_VALID_")}:{" "}
                  {operatingCompanies[0]?.isVehicleValid ? "True" : "False"}
                </span>
                <span style={{ display: "block" }}>
                  {this.context.translate("_REGISTRATION_TIME_")}:{" "}
                  {operatingCompanies[0]?.registrationTime}
                </span>
                <span style={{ display: "block" }}>
                  {this.context.translate("Vehicle Rejection Reason")}:{" "}
                  {operatingCompanies[0]?.vehicleRejectionReason}
                </span>
              </>
            )}
          </div>
        </Modal>
      </>
    );
  }
}
WASLVehicleList.contextType = StoreContext;
export default observer(withRouter(WASLVehicleList));
